import { Component, OnInit } from '@angular/core';
import { DatePipe } from '@angular/common';
 
import { Router } from '@angular/router';
import { EmployeeExitClearanceDto } from 'src/app/models/EmployeeExitClearanceDto';
import { ExitClearanceApprovalDto } from 'src/app/models/ExitClearanceApprovalDto';
import { PendingExitApprovalModel } from 'src/app/models/PendingExitApprovalModel';
import { approveMovementVm } from 'src/app/models/approveMovementVm';
import { NotificationType } from 'src/app/models/notification.message';
import { ExitClearanceService } from 'src/app/services/exit-clearance.service';
import { NotificationService } from 'src/app/services/notification.service';
import { UserService } from 'src/app/services/user.service';
@Component({
  selector: 'app-authorize-exit-clearance',
  templateUrl: './authorize-exit-clearance.component.html',
  styleUrls: ['./authorize-exit-clearance.component.css']
})
export class AuthorizeExitClearanceComponent implements OnInit {

  currentUser: any;
  Requests: PendingExitApprovalModel[] = [];
  isPendingpprovalModalVisible = false;
  ExitRequest: EmployeeExitClearanceDto  |null =null;
  isCancelVisible:boolean=false;
  ExitRequestApprovals: ExitClearanceApprovalDto[] | undefined;
  MyPendingExitRequestApprovals: ExitClearanceApprovalDto[] | undefined;
  ViewExitRequestVisible = false;
  canPrint: boolean = false;



  constructor( private notification: NotificationService,  private router: Router, public datepipe: DatePipe,private userService: UserService, private exitClearanceService:ExitClearanceService) 
  {



   }

  ngOnInit(): void {
      
   this. loadRecords();
  }

  handleCancel(): void {
    this.isPendingpprovalModalVisible = false;
    this.isCancelVisible = false;
    
  }

  getStatusColor(status: string): string { 
    switch (status) {
      case "New":
        return 'badge badge-warning';
      case "Pending":
        return 'badge badge-warning';
      case "Approved":
        return 'badge badge-success';
      case "Rejected":
        return 'badge badge-danger';
        case "Closed":
          return 'badge badge-success';
          case "Cancelled":
            return 'badge badge-danger';
      default:
        return 'badge badge-info';
    }}

    downloadExcel() 
    {

    }

    async open(data: PendingExitApprovalModel) 
    {
      this.MyPendingExitRequestApprovals = data.approvals;
     this.ExitRequest =data.exitClearance;
      this.ViewExitRequestVisible = true;
   
  
    }
    async openapproval(data: PendingExitApprovalModel)
    {

      let resRequests = await this.exitClearanceService.GetExitClearanceApprovalByClearance(data.exitClearance.id).toPromise();
      this.ExitRequestApprovals = <ExitClearanceApprovalDto[]>resRequests.responseData;

      this.isPendingpprovalModalVisible = true;
    }
    async loadRecords() {
      ;
      //this.currentUser = this.tokenService.getInfo(); 
      let resRequests = await this.exitClearanceService.GetMyPendingAuthorisation().toPromise();
      this.Requests = <PendingExitApprovalModel[]>resRequests.responseData;
    
    }
    async handleSubmit() {


    }

    close(): void {
      this.ViewExitRequestVisible = false;
      this.canPrint = false;
      
    }

    print(requestReference:EmployeeExitClearanceDto, templateId:string) {
     // this.documentService.DownloadPDF(templateId, `Movement Request - ${requestReference}`);
    }

    async AuthorizeClearance(ExitClearanceApproval: EmployeeExitClearanceDto  ) {
      // this.isManPowerpprovalModalVisible = true;
         ; 
         const model: approveMovementVm = { id: ExitClearanceApproval.id,  message: "Approved" };
         
          this.exitClearanceService.AuthorizeClearance(model).subscribe({
            next: (data => {
              
              if (data.responseCode == "00") {
                this.notification.sendMessage({
                  message: data.message,
                  type: NotificationType.success
                });
   
                this.loadRecords();
                this.close()
                location.reload();
              }
              else {
   
                this.notification.sendMessage({
                message: data.message,
                  type: NotificationType.error
                });
   
              }
   
            }),
            error: ((error: any) => {
              console.log(error.error);
              ;
   
   
              this.notification.sendMessage({
                message: error.error.message,
                type: NotificationType.error
              });
            })
   
          });
   
     }


}
